import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { getIsTabExpanded } from '@tabeeb/modules/sessionTabs/selectors'
import { TabPanel } from '@tabeeb/enums'
import { getPagesByFolder } from '../selectors'

import GalleryList from '../components/GalleryList'

class GalleryListContainer extends Component {
  componentDidUpdate(prevProps) {
    const { selectedGalleryItemId, setSelectedItemRef } = this.props

    const prevGalleryList = prevProps.galleryList
    const { galleryList } = this.props

    if (galleryList !== prevGalleryList && prevGalleryList) {
      const notRenderedSelectedItem = document.getElementById(selectedGalleryItemId)

      if (notRenderedSelectedItem) setSelectedItemRef(notRenderedSelectedItem)
    }
  }

  render() {
    const { galleryList, listRef, setSelectedItemRef, isGalleryExpanded, isDragAvailable } = this.props

    const props = {
      galleryList,
      listRef,
      setSelectedItemRef,
      isGalleryExpanded,
      isDragAvailable,
    }

    return <GalleryList {...props} />
  }
}

GalleryListContainer.propTypes = {
  galleryList: PropTypes.array,
  listRef: PropTypes.object,
  setSelectedItemRef: PropTypes.func.isRequired,
  selectedGalleryItemId: PropTypes.number,
  isGalleryExpanded: PropTypes.bool,
  isDragAvailable: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => {
  const galleryList = getPagesByFolder(state)

  return {
    selectedGalleryItemId: state.gallery.galleryState.selectedGalleryItemId,
    galleryList,
    isGalleryExpanded: getIsTabExpanded(state, TabPanel.Gallery),
  }
}

export default connect(mapStateToProps, null)(GalleryListContainer)
